import { DefaultError, useQuery } from '@tanstack/react-query';
import { useResponseHandler } from 'utils/service/responseHandler';
import { apiClient } from 'utils';
import { IMerchLight } from './types';

export const useGetMerchLightList = () => {
  const { responseHandler } = useResponseHandler();
  return useQuery<IMerchLight[], DefaultError>({
    queryKey: ['merch-light-list'],
    async queryFn() {
      const response = await apiClient({
        method: 'GET',
        url: `Merch/LightList`,
      });

      return responseHandler(response, {
        groupName: `useGetMerchLightList`,
      });
    },
  });
};
